import React, { useState } from 'react';
import c from 'classnames';
import * as ReactGA from 'react-ga';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './SocialBar.css';
import { Device } from '../../device';
import { SOCIALBAR } from '../../lib/labels';
import { useQueryCommandIsSupported, copyTextToClipboard } from '../commons/hooks';

const socialConfig = (itemId, itemTitle) => {
  const itemUrl = `https://www.dumpert.nl/item/${itemId}`;
  const encodeSharingText = encodeURIComponent(`Check '${itemTitle}' op Dumpert `);
  const encodeSharingUrl = encodeURIComponent(itemUrl);
  return ({
    sharing: {
      href_facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeSharingUrl}&t=${encodeSharingText}`,
      href_whatsapp: `https://api.whatsapp.com/send?text=${encodeSharingText}${encodeSharingUrl}`,
      href_twitter: `https://twitter.com/intent/tweet?text=${encodeSharingText}&url=${encodeSharingUrl}`,
      href_link: itemUrl,
    },
    links: {
      href_facebook: 'https://www.facebook.com/dumpertnl',
      href_instagram: 'https://www.instagram.com/dumpert',
      href_youtube: 'https://www.youtube.com/dumpert',
      href_twitter: 'https://www.twitter.com/dumpert',
    },
  });
};

const sharingGAEvent = (action, itemId) => () => ReactGA.event({
  category: `Sharing ${Device.IS_DESKTOP ? 'Desktop' : 'Mobile'}`,
  action: `${action.charAt(0).toUpperCase() + action.slice(1)} share`,
  label: itemId,
}); 

export const SocialBar = ({ isSharing, itemId, itemTitle }) => {
  const { 
    href_facebook, 
    href_whatsapp, 
    href_instagram, 
    href_youtube,
    href_twitter,
    href_link,
  } = socialConfig(itemId, itemTitle)[isSharing ? 'sharing' : 'links'];
  
  const copyIsSupported = useQueryCommandIsSupported();
  const [copySuccess, setCopySuccess] = useState(false);

  return (
    <div className={c(
      styles.socialbar,
      { [styles.links]: !isSharing },
    )}>
      <a href={href_facebook} target="_blank" rel="noopener noreferrer"
        onClick={isSharing ? sharingGAEvent('facebook', itemId) : null}
        aria-label={`${isSharing ? 'Link delen' : 'Dumpert'} op Facebook`}
        id={isSharing ? 'facebook-share' : 'facebook-link'}
      >
        <FontAwesomeIcon icon={['fab', 'facebook-f']} size="2x" />
        <span>facebook</span>
      </a>
      {isSharing && (
        <a href={href_whatsapp} target="_blank" rel="noopener noreferrer"
          onClick={sharingGAEvent('whatsapp', itemId)}
          aria-label="Link delen op Whatsapp"
          id='whatsapp-share'
        >
          <FontAwesomeIcon icon={['fab', 'whatsapp']} size="2x" />
          <span>whatsapp</span>
        </a>
      )}
      {!isSharing && (
        <>
          <a href={href_instagram} target="_blank" rel="noopener noreferrer"
            aria-label="Dumpert op Instagram"
            id='instagram-link'
          >
            <FontAwesomeIcon icon={['fab', 'instagram']} size="2x" />
            <span>instagram</span>
          </a>
          <a href={href_youtube} target="_blank" rel="noopener noreferrer"
            aria-label="Dumpert op Youtube"
            id='youtube-link'        
          >
            <FontAwesomeIcon icon={['fab', 'youtube']} size="2x" />
            <span>youtube</span>
          </a>
        </>
      )}
      <a href={href_twitter} target="_blank" rel="noopener noreferrer"
        onClick={isSharing ? sharingGAEvent('twitter', itemId) : null}
        aria-label={`${isSharing ? 'Link delen' : 'Dumpert'} op Twitter`}   
        id={isSharing ? 'twitter-share' : 'twitter-link'}      
      >
        <FontAwesomeIcon icon={['fab', 'twitter']} size="2x" />
        <span>twitter</span>
      </a>
      {!isSharing && <a href='https://api-live.dumpert.nl/mobile_api/json/rss' rel="noopener noreferrer"
        target="_blank">
        <FontAwesomeIcon icon="rss" size="2x" />
        <span>rss</span>
      </a>}
      {(isSharing && copyIsSupported) && (   
        <div
          onClick={() => {
            copyTextToClipboard(href_link, () => {
              setCopySuccess(true);
              setTimeout(() => {
                setCopySuccess(false);
              }, 2000); 
            });
            sharingGAEvent('link', itemId)();
          }}
          className={styles.url_copy}
          aria-label="Link kopieren"
          id='link-share'
        >
          <FontAwesomeIcon icon={['fas', 'link']} size="2x" />
          <span>link</span>
          {copySuccess && (<div className={styles.copy_success}>{SOCIALBAR.COPIED}</div>)}
        </div>
      )}    
      {/*
        ICONS FOR SAVING POSTS IN FUTURE
        <a href="#" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={['far', 'heart']} size="2x" />
        <FontAwesomeIcon icon={['fas', 'heart']} size="2x" />
      </a>*/}
    </div>
  );
};



